import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import { removeDiscount } from '../../order/actions';
import OrderInfoDiscountItem from '../components/OrderInfoDiscountItem';
import { getDiscountById } from '../../validated/selectors';


export default compose(
  connect((state, ownProps) => ({
    item: getDiscountById(state, ownProps.id),
  }), { removeDiscount }),
  withHandlers({
    removeItem: props => () => props.removeDiscount(props.id),
  })
)(OrderInfoDiscountItem);
